import React from "react";
import { Button } from "@/components/ui/button";
import { formatMonth } from "@/lib/format";
import { currentMonth, shiftMonth } from "@/lib/householdConstants";
import { ChevronLeft, ChevronRight } from "lucide-react";

/** Måneds-navigasjon: forrige / «Oktober 2026» / neste / «I dag». */
export const MonthPicker = ({ month, onChange, testId = "household-month" }) => {
  const cur = currentMonth();
  return (
    <div className="inline-flex items-center gap-1 rounded-xl border bg-card p-1" data-testid={`${testId}-picker`}>
      <Button variant="ghost" size="icon" className="h-9 w-9" onClick={() => onChange(shiftMonth(month, -1))} aria-label="Forrige måned" data-testid={`${testId}-prev`}><ChevronLeft className="h-4 w-4" /></Button>
      <span className="min-w-[150px] text-center font-medium" data-testid={`${testId}-label`}>{formatMonth(month)}</span>
      <Button variant="ghost" size="icon" className="h-9 w-9" onClick={() => onChange(shiftMonth(month, 1))} aria-label="Neste måned" data-testid={`${testId}-next`}><ChevronRight className="h-4 w-4" /></Button>
      {month !== cur ? <Button variant="outline" size="sm" className="h-9" onClick={() => onChange(cur)} data-testid={`${testId}-today`}>Denne måneden</Button> : null}
    </div>
  );
};
